// 约爱占位页 K22D4(页面-约爱-尚未发布)— 2026-06-05 module spec 追加裁决:
// 本期仅占位「尚未发布/敬请期待」;完整模块页(分类导航 + feed + #FF4D6D 主题)后期实现。
// 设计:居中插画(粉色光晕 + 信封 + 心形)+ 标题/副标题;带 TabBar(约爱 tab 激活)。
import { MobileScreen } from '../components/mobile-screen'
import { TabBar } from '../components/tab-bar'

export function DatingComingSoonPage() {
  return (
    <MobileScreen bg="white">
      <div
        data-testid="K22D4"
        className="flex flex-1 flex-col items-center justify-center gap-6 px-10 pb-20"
      >
        {/* illustration(zGqiF 重绘:光晕 + 信封 + 心形 + 点缀) */}
        <div className="relative h-[200px] w-[200px]">
          <div className="absolute left-[10px] top-[20px] h-[180px] w-[180px] rounded-full bg-[radial-gradient(circle,_#FFE5EA_0%,_#FFFFFF_70%)]" />
          <div className="absolute left-[35px] top-[45px] h-[130px] w-[130px] rounded-full bg-[#FFD6DE]" />
          <div className="absolute left-[40px] top-[158px] h-[14px] w-[120px] rounded-full bg-[#FF4D6D1F]" />
          {/* envelope */}
          <svg className="absolute left-[40px] top-[88px]" width="120" height="78" viewBox="0 0 120 78" fill="none">
            <rect y="6" width="120" height="72" rx="10" fill="#FFB3C1" />
            <rect y="14" width="120" height="64" rx="10" fill="#FFC9D4" />
            <path d="M0 16 L60 48 L120 16 V68 a10 10 0 0 1-10 10 H10 A10 10 0 0 1 0 68 Z" fill="#FFE5EA" stroke="#FFFFFF" strokeWidth="1.5" />
          </svg>
          {/* heart(浮在信封上方) */}
          <svg className="absolute left-[74px] top-[38px]" width="52" height="46" viewBox="0 0 24 24" fill="#FF4D6D" stroke="#FFFFFF" strokeWidth="1.5">
            <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
          </svg>
          {/* sparkles / dots */}
          <span className="absolute left-[30px] top-[44px] text-[13px] text-[#FF4D6D]">✦</span>
          <span className="absolute left-[152px] top-[28px] text-[10px] text-[#FFB3C1]">✦</span>
          <span className="absolute left-[160px] top-[94px] text-[8px] text-[#FF4D6D]">✦</span>
          <span className="absolute left-[28px] top-[110px] h-[6px] w-[6px] rounded-full bg-[#FFB3C1]" />
          <span className="absolute left-[168px] top-[140px] h-[5px] w-[5px] rounded-full bg-[#FF4D6D]" />
        </div>
        <div className="flex flex-col items-center gap-3">
          <p className="text-[22px] font-semibold text-[#1A1A1A]">尚未发布</p>
          <p className="text-[15px] tracking-[2px] text-[#9CA3AF]">敬请期待</p>
        </div>
      </div>
      <TabBar />
    </MobileScreen>
  )
}
